import { useRoleCacheRefresh } from "./useRoleCacheRefresh";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useProtected, useAuth } from "src/context";

export const useUserSessionInit = () => {
  const navigate = useNavigate();
  const { processMagicLink } = useAuth();
  const isProtected = useProtected();
  useRoleCacheRefresh();

  useEffect(() => {
    if (!isProtected) {
      processMagicLink(navigate);
    }

    return () => {
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier = undefined;
      }
    };
  }, []);
};
